import React, { useState, useEffect } from "react";
import logo from "../../images/Kodo-new.svg";
import icon1 from "../../images/icons/icon_mail.svg";
import MobileMenu from "../MobileMenu/MobileMenu";
import { Link } from "react-router-dom";

const Header = () => {
  const [mobailActive, setMobailState] = useState(false);
  const [isSticky, setSticky] = useState(false);

  // Sticky header on scroll
  useEffect(() => {
    const handleScroll = () => setSticky(window.scrollY > 80);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header className="site_header site_header_1">
      {/* ====== TOP BANNER ====== */}
      <div
        className="header_top text-center"
        style={{
          background: "#673ee5" ,
          color: "#fff",
        }}
      >
        <div className="container">
          <p className="m-0">
            <strong>Limited Seats</strong> : Kodo Program Commences On
            <b> January 5, 2026</b>.{" "}
            <Link to="/contact">
              <u>Apply Now</u> <i className="fa-solid fa-angle-right"></i>
            </Link>
          </p>
        </div>
      </div>

      {/* ====== MAIN NAVBAR ====== */}
      <div
        className={`header_bottom stricky ${
          isSticky ? "stricked-menu stricky-fixed" : ""
        }`}
      >
        <div className="container">
          <div className="row align-items-center">
            {/* Logo */}
            <div className="col-xl-3 col-lg-3 col-md-4 col-5">
              <div className="site_logo">
                <Link className="site_link" to="/">
                  <img
                    src={logo}
                    className="ms-4"
                    alt="Site Logo – Kodo Program"
                  />
                </Link>
              </div>
            </div>

            {/* Desktop Nav */}
            <div className="col-xl-6 col-lg-6 col-md-2 col-2">
              <nav className="main_menu navbar navbar-expand-lg">
                <div
                  className="main_menu_inner collapse navbar-collapse justify-content-lg-center d-none d-lg-block"
                  id="main_menu_dropdown"
                >
                  <ul className="main_menu_list unordered_list justify-content-center">
                    <li>
                     <a href="/">Home</a>
                    </li>
                    <li>
                      <a
                        href="#program"
                        className="nav-link"
                        onClick={() => setMobailState(false)}
                      >
                        Program
                      </a>
                    </li>
                    <li>
                      <a
                        href="#highlights"
                        className="nav-link"
                        onClick={() => setMobailState(false)}
                      >
                        Highlights
                      </a>
                    </li>
                  
                      <li>
                         <Link to="/contact">Contact Us</Link>
                    </li>
                  </ul>
                </div>
              </nav>
            </div>

            {/* Right Buttons */}
            <div className="col-xl-3 col-lg-3 col-md-6 col-5">
              <ul className="header_btns_group unordered_list justify-content-end d-flex flex-row gap-2">
                {/* Mobile toggle */}
                <li>
                  <button
                    className="mobile_menu_btn"
                    onClick={() => setMobailState(!mobailActive)}
                    type="button"
                    aria-label="Toggle navigation"
                  >
                    <i className="far fa-bars"></i>
                  </button>
                </li>

                {/* Let's Talk button */}
                <li>
                  <Link
                    className="btn d-md-none d-lg-block"
                    to="/lets-talk"
                    style={{
                      background: "#673ee5",
                      color: "#fff",
                      border: "none",
                    }}
                  >
                    <span className="btn_label">Let's Talk</span>
                    <span className="btn_icon ms-2">
                      <img src={icon1} alt="mail" />
                    </span>
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* ====== MOBILE MENU ====== */}
        <div className="mobail-wrap">
          <div className={`mobail-menu ${mobailActive ? "active" : ""}`}>
            <div className="xb-header-menu-scroll">
              <div
                className="xb-menu-close xb-hide-xl xb-close"
                onClick={() => setMobailState(false)}
              ></div>
              <nav className="xb-header-nav">
                <MobileMenu />
              </nav>
            </div>
          </div>
          <div
            className="xb-header-menu-backdrop"
            onClick={() => setMobailState(false)}
          ></div>
        </div>
      </div>
    </header>
  );
};

export default Header;
